import {
    useState,
    useRef,
    useMemo,
    useEffect,
    useLayoutEffect
} from 'react'
import { useUser } from '@shared/hooks/user'
import { useDialogContext } from '@shared/hooks/dialogContext'
import { useRestFetch } from '@shared/hooks/rest/fetch'
import { useMethods } from '@shared/hooks/methods'
import { docs } from './data/dict'

export const useDocs = () => {
    const {
        form: {
            setValue,
            getValues
        },
        urls,
        viewFields
    } = useDialogContext()
    const { showMessage } = useMethods()
    
    const [tabValue, setTabValue] = useState('def')
    const [doc, setDoc] = useState(null)
    const [generating, setGenerating] = useState(false)
    const docRef = useRef(null)

    // scroll
    const contentRef = useRef(null) 
    const scrollPos = useRef(0)
    const user = useUser()
    const offices = useRestFetch({
        key: ['offices'],
        endpoint: 'settings/offices/'
    })
    const delegates = useRestFetch({
        key: ['pdc-delegates'],
        endpoint: 'settings/pdc-delegates/'
    })
    const [coordinates, setCoordinates] = useState([0, 0])

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
            function (position) {
                setCoordinates([position.coords.latitude.toFixed(5), position.coords.longitude.toFixed(5)])
            },
            function () {
                showMessage('لم نتمكن من جلب إحداثياتك.')
            }
        )
    }, [])

    const resolvedDocs = useMemo(() => docs({
        contractor: getValues('contractor'),
        number: getValues('number'),
        dep: 'الرياض',
        div: offices.data.find(o => o.id == getValues('office'))?.name || '',
        district: getValues('district'),
        user: {
            name: `${user.first_name} ${user.last_name}`,
            signature: user.signature
        },
        supervisor: {
            name: getValues('supervisor_name'),
            signature: getValues('supervisor_signature')
        },
        feeder: getValues('station_no'),
        equipment_no: getValues('equipment_no') || '',
        site_type: getValues('site_type'),
        notes: getValues('notes'),
        delegate: delegates.data.find(delegate => delegate.id == getValues('pdc_delegate')) || {},
        x: coordinates[0],
        y: coordinates[1]
    }), [getValues, user, coordinates, offices.data])

    const handleSelection = (d) => {
        if (contentRef.current) {
            scrollPos.current = contentRef.current.scrollTop
        }
        setDoc(d)
    }

    useLayoutEffect(() => {
        if (!doc && contentRef.current) {
            contentRef.current.scrollTop = scrollPos.current
        }
    }, [doc])

    const handleAdd = async () => {
        if (!docRef.current) return
        setGenerating(true)
        try {
            const blob = await docRef.current.generate()
            const fileName = `${doc.text}-${Date.now()}.jpeg`
            const file = new File([blob], fileName, { type: 'image/jpeg' })
            const url = URL.createObjectURL(file)

            urls.current = [...urls.current, url]

            const prevImages = getValues('images') || []
            setValue('images', [
                ...prevImages,
                {
                    id: crypto.randomUUID(),
                    file: file,
                    url,
                    dep: 'documents'
                }
            ], {
                shouldDirty: true,
                shouldValidate: true,
            })

            setDoc(null)
        } finally {
            setGenerating(false)
        }
    }

    return {
        doc,
        setDoc,
        contentRef,
        tabValue,
        setTabValue,
        resolvedDocs,
        user,
        docRef,
        viewFields,
        generating,
        handleAdd,
        handleSelection
    }
}